"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../../");

var _NavTooltip = _interopRequireDefault(require("./NavTooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var SidebarExpandToggle = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(SidebarExpandToggle, _React$PureComponent);

  var _super = _createSuper(SidebarExpandToggle);

  function SidebarExpandToggle() {
    var _this;

    (0, _classCallCheck2["default"])(this, SidebarExpandToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", function (e) {
      var _this$props = _this.props,
          expanded = _this$props.expanded,
          setExpanded = _this$props.setExpanded,
          setExpandedKeys = _this$props.setExpandedKeys;
      e.preventDefault();

      if (expanded) {
        setExpanded(false); // also collapse any expanded submenus

        setExpandedKeys({});
      } else {
        setExpanded(true);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(SidebarExpandToggle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          inverted = _this$props2.inverted;
      var tooltip = expanded ? 'Collapse' : 'Expand';
      return /*#__PURE__*/_react["default"].createElement(_NavTooltip["default"], {
        className: (0, _classnames["default"])('sidebar expand-toggle', {
          expanded: expanded
        }),
        content: tooltip,
        inverted: inverted,
        position: "right center",
        popperDependencies: [tooltip],
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "toggle",
          onClick: this.onClick
        }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
          name: "chevron-right"
        }))
      });
    }
  }]);
  return SidebarExpandToggle;
}(_react["default"].PureComponent);

var _default = SidebarExpandToggle;
exports["default"] = _default;